import wizard from 'root/main/components/wizard/wizard';
import wizardForm from 'root/main/components/wizardForm/wizardForm';

export const initializeWizardFormLightboxes = () => {
    const wizards: HTMLElement[] = Array.from(
        document.querySelectorAll('[data-wizard=""]')
    );
    wizard(wizards);
    const wizardForms: HTMLElement[] = Array.from(
        document.querySelectorAll('[data-wizard-form=""]')
    );
    wizardForm(wizardForms);
};
